import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SignProcessWizardService } from '../../sign-process-wizard.service';

@Component({
  selector: 'ss-review-step',
  templateUrl: './review-step.component.html',
  styleUrls: ['./review-step.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewStepComponent implements OnInit {

  readonly processIdSubject = new BehaviorSubject<string>(null)
  @Input() get processId() {
    return this.processIdSubject.value
  }
  set processId(value) {
    this.processIdSubject.next(value)
  }

  get otherElements() {
    return this._signProcessWizardService.otherElements
  }

  get baseElement() {
    return this._signProcessWizardService.baseElement;
  }


  constructor(
    private readonly _signProcessWizardService: SignProcessWizardService
  ) { }

  ngOnInit(): void {
  }

}
